import React, { useState } from "react";
import { Layout, Menu } from "antd";
import SingleUserRegister from "../../components/admin/SingleUserRegister";
import BulkRegister from "../../components/admin/BulkRegister";
import PrintableUsers from "../../components/admin/PrintableUsers";
import DMCPanel from "../../pages/DMCPanel";
import Classes from "../../pages/Classes";
import Groups from "../../pages/Groups";
import Group from "../../pages/Group";
import ReflectionsDashboard from "../../pages/ReflectionsDashboard";
import StoriesGallery from "../../pages/StoriesGallery";
import StoryEditor from "../../pages/story-editor/StoryEditor";

const { Sider, Content } = Layout;
const { SubMenu } = Menu;

const TeacherDashboard = () => {
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [activeKey, setActiveKey] = useState("register");

  const renderContent = () => {
    switch (activeKey) {
      case "register":
        return <SingleUserRegister />;

      case "bulk":
        return <BulkRegister />;

      case "printable":
        return <PrintableUsers />;

      case "klasse":
        return <Classes />;

      case "groups":
        return selectedGroup ? (
          <Group
            group={selectedGroup}
            onBack={() => setSelectedGroup(null)}
          />
        ) : (
          <Groups onSelect={setSelectedGroup} />
        );

      case "stories":
        return <StoriesGallery />;

      case "reflections":
        return <ReflectionsDashboard />;

      case "dmcpanel":
        return <DMCPanel />;

        case "writeStory":
          return <StoryEditor />;
        

      default:
        return <SingleUserRegister />;
    }
  };

  return (
    <Layout className="teacher-dashboard">
      <Sider
        width={220}
        theme="light"
        className="teacher-sidebar"
      >
        <Menu
          mode="inline"
          selectedKeys={[activeKey]}
          defaultOpenKeys={["usersManagement"]}
          className="teacher-sidebar-menu"
          onClick={({ key }) => setActiveKey(key)}
        >
          <SubMenu
            key="usersManagement"          
            title="Benutzer"
          >
            <Menu.Item key="register">
             Registrieren
            </Menu.Item>

            <Menu.Item key="bulk">
              Bulk registrieren
            </Menu.Item>

            <Menu.Item key="printable">
              Benutzer drucken
            </Menu.Item>
          </SubMenu>

          <Menu.Item key="klasse" >
            Klasse
          </Menu.Item>

          <Menu.Item key="groups" >
            Gruppen
          </Menu.Item>


          <SubMenu
            key="Geschichtenverwaltung"
           
            title="Geschichten"
          >

            <Menu.Item key="stories" >
              Geschichten
            </Menu.Item>

            <Menu.Item key="writeStory"  >
              Geschichte schreiben {/* Write Story */}
            </Menu.Item>

          </SubMenu>



          <Menu.Item
            key="reflections"
           
          >
            Nachdenken
          </Menu.Item>

          <Menu.Item
            key="dmcpanel"
           
          >
            Mediensteuerung
          </Menu.Item>
        </Menu>
      </Sider>

      <Content className="teacher-dashboard-content">
        {renderContent()}
      </Content>
    </Layout>
  );
};

export default TeacherDashboard;